import * as React from "react";
import { V7_ROPERTIES_LENDERLIST } from '../../consts/queries';
import { executeQuery } from "../../requests/executeQuery";
import ListTable from '../ListTable';
import { useEffect } from "react";
const LenderProperty = (props) => {
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const fetch = () => {

        const options = {
            "param": {
                "limit": 1000,
                "offset": 0,
                "LENDER_ID":props.data.ARCIMEDES_ROW_ID
            },
            "filter": {
                "where": []
            },

        }
        setLoading(true);
        Promise.all([
            executeQuery({ queryName: V7_ROPERTIES_LENDERLIST, options, expireTime: 1000 }),          
        ]).then(values => {         
            let result = values[0].data.map((e) => {
                e.SELECTED = false;
                return e;
            });
            setData(result);
            setLoading(false);
        });
    }

    useEffect(() => {
        if (props.propertiesData && props.propertiesData.length == 0) {
            
            fetch();
        }
        else if(props.propertiesData && props.propertiesData.length>0){
            let result = props.propertiesData.filter((e) => e.LENDER_NAME === props.data.NAME)
            result = result.map((e) => {
                e.SELECTED = false;
                return e;
            });
            setData(result);
        }
    }, [])

    return (
        <div className="LenderProperty-info">
            {data.length == 0 && loading == false && <p>No Records Found</p>}
            {data.length == 0 && loading == true && <p>Loading...please wait </p>}
            <ListTable location={{
                query: {}
            }}
                listings={data}
                everySummitRecord={true}
                isLender={true}

            />


        </div>
    );
};

export default LenderProperty;
